import { CharacterFeature } from "@next-platform/packages-ts-types";
import { useCallback, useMemo } from "react";
import { useTranslation } from "../hooks";
export default function useTranslatedCharacterFeature() {
    const { t } = useTranslation();
    const labelByFeature = useMemo(() => ({
        [CharacterFeature.LOREBOOK]: t("chatbotFilters:filterByFeatures.options.lorebook.label"),
        [CharacterFeature.RULEBOOK]: t("chatbotFilters:filterByFeatures.options.rulebook.label"),
        [CharacterFeature.VOICE]: t("chatbotFilters:filterByFeatures.options.voice.label"),
        [CharacterFeature.CUSTOM_VOICE]: t("chatbotFilters:filterByFeatures.options.custom_voice.label"),
    }), [t]);
    const subtitleByFeature = useMemo(() => ({
        [CharacterFeature.LOREBOOK]: t("chatbotFilters:filterByFeatures.options.lorebook.subtitle"),
        [CharacterFeature.RULEBOOK]: t("chatbotFilters:filterByFeatures.options.rulebook.subtitle"),
        [CharacterFeature.VOICE]: t("chatbotFilters:filterByFeatures.options.voice.subtitle"),
        [CharacterFeature.CUSTOM_VOICE]: t("chatbotFilters:filterByFeatures.options.custom_voice.subtitle"),
    }), [t]);
    const getFeatureLabel = useCallback((value) => labelByFeature[value], [labelByFeature]);
    const getFeatureSubtitle = useCallback((value) => subtitleByFeature[value], [subtitleByFeature]);
    return { getFeatureLabel, getFeatureSubtitle };
}
